import * as moment from 'moment';
import { dispatch } from 'store';

import {
  editGuestSession,
  removeGuestSession,
  updateGuestSessions,
  editGuestSessionAtomic,
  updateGuestSessionData,
  updateGuestSessionsData,
  editGuestSessionDataAtomic,
  removeGuestSessionSpending,
  updateGuestSessionsSpendings } from 'store/actions';

import { api } from '..';

const handleGetAllGuestSessionsDetails = () => new Promise((resolve, reject) => {
  api.get('/api/guest-session/fetchAllGuestSessionDetails').then(({ data: { error, data } }) => {
    if (error) reject();
    else {
      dispatch(updateGuestSessionsData({ data, section: 'details' }));
      resolve();
    }
  });
});

const handleGetGuestSessionsDetails = (id) => new Promise((resolve, reject) => {
  api.get('/api/guest-session/fetchGuestSessionDetails', { params: { id } }).then(({ data: { error, data } }) => {
    if (error) reject();
    else {
      dispatch(updateGuestSessionsData({ data, section: 'details' }));
      resolve();
    }
  });
});

const handleGetAllGuestSessionsInquiryForm = () => new Promise((resolve, reject) => {
  api.get('/api/guest-session/fetchAllGuestSessionInquiryForm').then(({ data: { error, data } }) => {
    if (error) reject();
    else {
      dispatch(updateGuestSessionsData({ data, section: 'inquiryForm' }));
      resolve();
    }
  });
});

const handleGetGuestSessionsInquiryForm = (id) => new Promise((resolve, reject) => {
  api.get('/api/guest-session/fetchGuestSessionInquiryForm', { params: { id } }).then(({ data: { error, data } }) => {
    if (error) reject();
    else {
      dispatch(updateGuestSessionsData({ data, section: 'inquiryForm' }));
      resolve();
    }
  });
});

const handleGetAllGuestSessionsTravel = () => new Promise((resolve, reject) => {
  api.get('/api/guest-session/fetchAllGuestSessionTravel').then(({ data: { error, data } }) => {
    if (error) reject();
    else {
      dispatch(updateGuestSessionsData({ data, section: 'travel' }));
      resolve();
    }
  });
});

const handleGetGuestSessionsTravel = (id) => new Promise((resolve, reject) => {
  api.get('/api/guest-session/fetchGuestSessionTravel', { params: { id } }).then(({ data: { error, data } }) => {
    if (error) reject();
    else {
      dispatch(updateGuestSessionsData({ data, section: 'travel' }));
      resolve();
    }
  });
});

const handleGetAllGuestSessionsPreScreening = () => new Promise((resolve, reject) => {
  api.get('/api/guest-session/fetchAllGuestSessionPrescreening').then(({ data: { error, data } }) => {
    if (error) reject();
    else {
      dispatch(updateGuestSessionsData({ data, section: 'preScreening' }));
      resolve();
    }
  });
});

const handleGetGuestSessionsPreScreening = (id) => new Promise((resolve, reject) => {
  api.get('/api/guest-session/fetchGuestSessionPrescreening', { params: { id } }).then(({ data: { error, data } }) => {
    if (error) reject();
    else {
      dispatch(updateGuestSessionsData({ data, section: 'preScreening' }));
      resolve();
    }
  });
});

const handleGetAllGuestSessionsFinancing = () => new Promise((resolve, reject) => {
  api.get('/api/guest-session/fetchAllGuestSessionFinancing').then(({ data: { error, data } }) => {
    if (error) reject();
    else {
      dispatch(updateGuestSessionsData({ data, section: 'financing' }));
      resolve();
    }
  });
});

const handleGetGuestSessionsFinancing = (id) => new Promise((resolve, reject) => {
  api.get('/api/guest-session/fetchGuestSessionFinancing', { params: { id } }).then(({ data: { error, data } }) => {
    if (error) reject();
    else {
      dispatch(updateGuestSessionsData({ data, section: 'financing' }));
      resolve();
    }
  });
});

const handleGetAllGuestSessionsSpendings = () => new Promise((resolve, reject) => {
  api
    .get('/api/session-spending/fetchAllSpendings')
    .then(({ data: { error, data } }) => {
      if (error) reject();
      else {
        dispatch(updateGuestSessionsSpendings({ data }));
        resolve();
      }
    });
});

const handleGetGuestSessionsSpendings = (id) => new Promise((resolve, reject) => {
  api
    .get('/api/session-spending/fetchSpending', { params: { id } })
    .then(({ data: { error, data } }) => {
      if (error) reject();
      else {
        dispatch(updateGuestSessionsSpendings({ data }));
        resolve();
      }
    });
});

const getGuestSessionSpendingById = (id) => {
  api.get('/api/session-spending/fetchSpending', { params: { id } }).then(({ data: { error, data } }) => {
    if (!error) {
      dispatch(updateGuestSessionsSpendings({ data }));
    }
  });
};

const handleGetAllGuestSessions = () => {
  api.get('/api/guest-session/fetchAllGuestSessions').then(({ data: { error, data } }) => {
    if (!error) {
      dispatch(updateGuestSessions({ data }));
      Promise.all([
        handleGetAllGuestSessionsDetails(),
        handleGetAllGuestSessionsInquiryForm(),
        handleGetAllGuestSessionsTravel(),
        handleGetAllGuestSessionsPreScreening(),
        handleGetAllGuestSessionsFinancing(),
        handleGetAllGuestSessionsSpendings(),
      ]);
    }
  });
};

const handleGetGuestSessionById = (id) => {
  api.get('/api/guest-session/fetchGuestSession', { params: { id } }).then(({ data: { error, data } }) => {
    if (!error) {
      dispatch(updateGuestSessions({ data }));
      Promise.all([
        handleGetGuestSessionsDetails(id),
        handleGetGuestSessionsInquiryForm(id),
        handleGetGuestSessionsTravel(id),
        handleGetGuestSessionsPreScreening(id),
        handleGetGuestSessionsFinancing(id),
        handleGetGuestSessionsSpendings(id),
      ]);
    }
  });
};

const handleEditGuestSession = (formData, cb) => {
  api.post('/api/guest-session/editGuestSession', { ...formData }).then(({ data }) => {
    if (data.error) cb(false);
    else {
      dispatch(editGuestSession({ data: formData }));
      cb(true);
    }
  });
};

const handleCreateGuestSession = (formData, cb) => {
  api.post('/api/guest-session/createGuestSession', { ...formData }).then(({ data }) => {
    if (data.error) cb(false);
    else {
      const session = {
        [+data.id]: {
          id: +data.id,
          ...formData,
        },
      };
      dispatch(updateGuestSessions({ data: session }));
      cb(+data.id);
    }
  });
};

const handleEditAtomicGuestSession = (formData) => {
  const { id, section, field, value, updatedAt, updatedBy } = formData;

  if (field === 'protocolFocus') {
    const json = JSON.stringify(value);
    api
      .post('/api/guest-session/editGuestSessionAtomic', { id, section, field, value: json, updatedAt, updatedBy })
      .then(({ data: { error } }) => {
        if (!error) {
          dispatch(editGuestSessionAtomic({ data: { id, section, field, value, updatedAt, updatedBy } }));
        }
      });
  } else {
    api
      .post('/api/guest-session/editGuestSessionAtomic', { id, section, field, value, updatedAt, updatedBy })
      .then(({ data: { error } }) => {
        if (!error) {
          dispatch(editGuestSessionAtomic({ data: { id, section, field, value, updatedAt, updatedBy } }));
        }
      });
  }
};

const handleEditAtomicGuestSessionData = (formData) => {
  const { id, section, field, value, updatedAt, updatedBy } = formData;

  api
    .post('/api/guest-session/editGuestSessionDataAtomic', { id, section, field, value, updatedAt, updatedBy })
    .then(({ data: { error } }) => {
      if (!error) {
        dispatch(editGuestSessionDataAtomic({ data: { id, section, field, value, updatedAt, updatedBy } }));
      }
    });
};

const handleRemoveGuestSession = ({ id, deletedAt, deletedBy }, cb) => {
  api.post('/api/guest-session/removeGuestSession', { id, deletedAt, deletedBy })
    .then(({ data: { error } }) => {
      if (error) cb({ error: true, done: false });
      else {
        dispatch(removeGuestSession({ data: { id, deletedAt, deletedBy } }));
        cb({ error: false, done: true });
      }
    });
};

const handleCreateGuestSessionDetails = (id, formData) => new Promise((resolve, reject) => {
  const filteredFields = {
    id,
    cycle: formData.cycle.value,
    programPackage: formData.programPackage.value,
    programDate: formData.programDate.value,
    budget: formData.budget.value,
    deposit: formData.deposit.value,
    areaOfFocus: formData.areaOfFocus.value,
    notesForResort: formData.notesForResort.value,
    room: formData.room.value,
    reschedulingStatus: formData.reschedulingStatus.value,
  };

  api
    .post('/api/guest-session/createGuestSessionDetails', filteredFields)
    .then(({ data }) => {
      if (data.error) reject();
      else {
        dispatch(updateGuestSessionData({ id, section: 'details', fields: filteredFields }));
        resolve();
      }
    });
});

const handleUpdateGuestSessionDetails = (formData) => new Promise((resolve, reject) => {
  const filteredFields = {
    cycle: formData.cycle,
    programPackage: formData.programPackage,
  };

  api
    .post('/api/guest-session/updateGuestSessionDetails', formData)
    .then(({ data }) => {
      if (data.error) reject();
      else {
        dispatch(updateGuestSessionData({ id: formData.id, section: 'details', fields: filteredFields }));
        resolve();
      }
    });
});

const handleEditGuestSessionDetails = (id, formData) => new Promise((resolve, reject) => {
  const filteredFields = {
    id,
    cycle: formData.cycle.value,
    programPackage: formData.programPackage.value,
    programDate: formData.programDate.value,
    budget: formData.budget.value,
    deposit: formData.deposit.value,
    areaOfFocus: formData.areaOfFocus.value,
    notesForResort: formData.notesForResort.value,
    room: formData.room.value,
    reschedulingStatus: formData.reschedulingStatus.value,
  };

  api
    .post('/api/guest-session/editGuestSessionDetails', filteredFields)
    .then(({ data }) => {
      if (data.error) reject();
      else {
        dispatch(updateGuestSessionData({ id, section: 'details', fields: filteredFields }));
        resolve();
      }
    });
});

const handleCreateGuestSessionInquiryForm = (id, formData) => new Promise((resolve, reject) => {
  const filteredFields = {
    id,
    consultCurrentHealthIssues: formData.consultCurrentHealthIssues.value,
    consultProgramGoals: formData.consultProgramGoals.value,
    notesForProgramDirector: formData.notesForProgramDirector.value,
    currentHealthIssues: formData.currentHealthIssues.value,
    programGoals: formData.programGoals.value,
    anyAdditionalQuestions: formData.anyAdditionalQuestions.value,
  };

  api
    .post('/api/guest-session/createGuestSessionInquiryForm', filteredFields)
    .then(({ data }) => {
      if (data.error) reject();
      else {
        dispatch(updateGuestSessionData({ id, section: 'inquiryForm', fields: filteredFields }));
        resolve();
      }
    });
});

const handleEditGuestSessionInquiryForm = (id, formData) => new Promise((resolve, reject) => {
  const filteredFields = {
    id,
    consultCurrentHealthIssues: formData.consultCurrentHealthIssues.value,
    consultProgramGoals: formData.consultProgramGoals.value,
    notesForProgramDirector: formData.notesForProgramDirector.value,
    currentHealthIssues: formData.currentHealthIssues.value,
    programGoals: formData.programGoals.value,
    anyAdditionalQuestions: formData.anyAdditionalQuestions.value,
  };

  api
    .post('/api/guest-session/editGuestSessionInquiryForm', filteredFields)
    .then(({ data }) => {
      if (data.error) reject();
      else {
        dispatch(updateGuestSessionData({ id, section: 'inquiryForm', fields: filteredFields }));
        resolve();
      }
    });
});

const handleCreateGuestSessionPreScreening = (id, formData) => new Promise((resolve, reject) => {
  const filteredFields = {
    id,
    recentSurgeries: formData.recentSurgeries.value,
    recentSurgeryDetails: formData.recentSurgeryDetails.value,
    recreationalDrugs: formData.recreationalDrugs.value,
    recreationalDrugsDescription: formData.recreationalDrugsDescription.value,
    alcohol: formData.alcohol.value,
    alcoholDetails: formData.alcoholDetails.value,
    tobacco: formData.tobacco.value,
    allergiesFoodSensitivities: formData.allergiesFoodSensitivities.value,
    allergiesFoodSensitivitiesExp: formData.allergiesFoodSensitivitiesExp.value,
    pregrant: formData.pregrant.value,
    doYouNeedAssistanceToGoUpAndDown: formData.doYouNeedAssistanceToGoUpAndDown.value,
    okWithGroup: formData.okWithGroup.value,
  };

  api
    .post('/api/guest-session/createGuestSessionPreScreening', filteredFields)
    .then(({ data }) => {
      if (data.error) reject();
      else {
        dispatch(updateGuestSessionData({ id, section: 'preScreening', fields: filteredFields }));
        resolve();
      }
    });
});

const handleEditGuestSessionPreScreening = (id, formData) => new Promise((resolve, reject) => {
  const filteredFields = {
    id,
    recentSurgeries: formData.recentSurgeries.value,
    recentSurgeryDetails: formData.recentSurgeryDetails.value,
    recreationalDrugs: formData.recreationalDrugs.value,
    recreationalDrugsDescription: formData.recreationalDrugsDescription.value,
    alcohol: formData.alcohol.value,
    alcoholDetails: formData.alcoholDetails.value,
    tobacco: formData.tobacco.value,
    allergiesFoodSensitivities: formData.allergiesFoodSensitivities.value,
    allergiesFoodSensitivitiesExp: formData.allergiesFoodSensitivitiesExp.value,
    pregrant: formData.pregrant.value,
    doYouNeedAssistanceToGoUpAndDown: formData.doYouNeedAssistanceToGoUpAndDown.value,
    okWithGroup: formData.okWithGroup.value,
  };

  api
    .post('/api/guest-session/editGuestSessionPreScreening', filteredFields)
    .then(({ data }) => {
      if (data.error) reject();
      else {
        dispatch(updateGuestSessionData({ id, section: 'preScreening', fields: filteredFields }));
        resolve();
      }
    });
});

const handleCreateGuestSessionFinancing = (id, formData) => new Promise((resolve, reject) => {
  const filteredFields = {
    id,
    amountOfLoan: formData.amountOfLoan.value,
    downPayment: formData.downPayment.value,
    amountFinanced: formData.amountFinanced.value,
    financeCharge: formData.financeCharge.value,
    totalNumberOfPayments: formData.totalNumberOfPayments.value,
    monthlyInstallments: formData.monthlyInstallments.value,
    startDateOfLoan: formData.startDateOfLoan.value,
    endDateOfLoan: formData.endDateOfLoan.value,
    annualInterestRate: formData.annualInterestRate.value,
  };

  api
    .post('/api/guest-session/createGuestSessionFinancing', filteredFields)
    .then(({ data }) => {
      if (data.error) reject();
      else {
        dispatch(updateGuestSessionData({ id, section: 'financing', fields: filteredFields }));
        resolve();
      }
    });
});

const handleEditGuestSessionFinancing = (id, formData) => new Promise((resolve, reject) => {
  const filteredFields = {
    id,
    amountOfLoan: formData.amountOfLoan.value,
    downPayment: formData.downPayment.value,
    amountFinanced: formData.amountFinanced.value,
    financeCharge: formData.financeCharge.value,
    totalNumberOfPayments: formData.totalNumberOfPayments.value,
    monthlyInstallments: formData.monthlyInstallments.value,
    startDateOfLoan: formData.startDateOfLoan.value ? moment(formData.startDateOfLoan.value).format('YYYY-MM-DD') : null,
    endDateOfLoan: formData.endDateOfLoan.value ? moment(formData.endDateOfLoan.value).format('YYYY-MM-DD') : null,
    annualInterestRate: formData.annualInterestRate.value,
  };

  api
    .post('/api/guest-session/editGuestSessionFinancing', filteredFields)
    .then(({ data }) => {
      if (data.error) reject();
      else {
        dispatch(updateGuestSessionData({ id, section: 'financing', fields: filteredFields }));
        resolve();
      }
    });
});

const handleRescheduleSession = (formData, cb) => {
  api.post('/api/guest-session/rescheduleSession', { ...formData }).then(({ data }) => {
    if (data.error) cb(false);
    else {
      const session = {
        [+formData.id]: {
          ...formData,
          rescheduling: false,
        },
      };
      dispatch(updateGuestSessions({ data: session }));
      cb(true);
    }
  });
};

const handleCreateGuestSessionSpending = (formData) => new Promise((resolve, reject) => {
  api
    .post('/api/session-spending/createSpending', formData)
    .then(({ data }) => {
      if (data.error) reject();
      else {
        const spendingData = {
          [+data.id]: {
            id: data.id,
            ...formData,
          },
        };
        dispatch(updateGuestSessionsSpendings({ data: spendingData }));
        resolve();
      }
    });
});

const handleEditGuestSessionSpending = (formData) => new Promise((resolve, reject) => {
  api
    .post('/api/session-spending/editSpending', formData)
    .then(({ data }) => {
      if (data.error) reject();
      else {
        const spendingData = {
          [formData.id]: {
            ...formData,
          },
        };
        dispatch(updateGuestSessionsSpendings({ data: spendingData }));
        resolve({ error: false, done: true });
      }
    });
});

const handleRemoveGuestSessionSpending = (formData) => new Promise((resolve, reject) => {
  api
    .post('/api/session-spending/removeSpending', formData)
    .then(({ data: { error } }) => {
      if (error) reject();
      else {
        dispatch(removeGuestSessionSpending({ data: formData }));
        resolve();
      }
    });
});

const handleCreateGuestSpending = (formData, cb) => {
  api
    .post('/api/session-spending/createSpending', formData)
    .then(({ data }) => {
      if (data.error) cb({ error: true, done: false });
      else {
        const spendingData = {
          [+data.id]: {
            id: data.id,
            ...formData,
          },
        };
        dispatch(updateGuestSessionsSpendings({ data: spendingData }));
        cb({ error: false, done: true });
      }
    });
};

const handleEditGuestSpending = (formData, cb) => {
  api
    .post('/api/session-spending/editSpending', formData)
    .then(({ data }) => {
      if (data.error) cb({ error: true, done: false });
      else {
        const spending = { [formData.id]: formData };
        dispatch(updateGuestSessionsSpendings({ data: spending }));
        cb({ error: false, done: true });
      }
    });
};

const handleRemoveGuestSpending = (formData, cb) => {
  api
    .post('/api/session-spending/removeSpending', formData)
    .then(({ data: { error } }) => {
      if (error) cb({ error: true });
      else {
        dispatch(removeGuestSessionSpending({ data: formData }));
        cb({ error: false });
      }
    });
};

export default {
  handleEditGuestSession,
  handleEditGuestSpending,
  handleRescheduleSession,
  handleCreateGuestSession,
  handleRemoveGuestSession,
  handleRemoveGuestSpending,
  handleGetAllGuestSessions,
  handleCreateGuestSpending,
  handleGetGuestSessionById,
  handleEditAtomicGuestSession,
  handleEditAtomicGuestSessionData,
  handleEditGuestSessionDetails,
  handleUpdateGuestSessionDetails,
  handleCreateGuestSessionDetails,
  handleEditGuestSessionFinancing,
  handleCreateGuestSessionFinancing,
  handleEditGuestSessionInquiryForm,
  handleCreateGuestSessionInquiryForm,
  handleEditGuestSessionPreScreening,
  handleCreateGuestSessionPreScreening,
  handleEditGuestSessionSpending,
  handleCreateGuestSessionSpending,
  handleRemoveGuestSessionSpending,
};
